<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="要货单号111">
                <a-input v-model="queryParam.orderNo" placeholder="请输入要货单号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="门店名称">
                <a-input v-model="queryParam.storeName" placeholder="请输入门店名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商家名称">
                <a-input v-model="queryParam.merchantName" placeholder="请输入商家名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商品名称">
                <a-input v-model="queryParam.goodsName" placeholder="请输入商品名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="要货状态">
                <a-select v-model="queryParam.orderStatus" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">已审核</a-select-option>
                  <a-select-option :value="2">已发货</a-select-option>
                  <a-select-option :value="3">已取消</a-select-option>
                  <a-select-option :value="4">已入库</a-select-option>
                  <a-select-option :value="5">审核拒绝</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="申请时间">
                <a-range-picker
                  v-model="dateRange"
                  style="width: 100%"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  :ranges="dateRanges"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons" style="display: block; text-align: right;">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['retail:purchase:create']">
          <a-icon type="plus" />创建要货申请
        </a-button>
      </div>

      <!-- 创建要货单表单 -->
      <create-form ref="createForm" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="tableBordered"
      >
        <span slot="orderStatus" slot-scope="text">
          <a-tag :color="getStatusColor(text)">{{ getStatusText(text) }}</a-tag>
        </span>
        <span slot="progress" slot-scope="text, record">
          {{ record.finishedItemCount || 0 }}/{{ record.totalItemCount || 0 }}
        </span>
        <span slot="createTime" slot-scope="text">
          {{ parseTime(text) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['retail:purchase:query']">
            <a-icon type="eye" />详情
          </a>
          <a-divider type="vertical" v-if="hasItemStatus(record, ITEM_STATUS.PENDING_AUDIT)" />
          <a @click="handleApprove(record)" v-if="hasItemStatus(record, ITEM_STATUS.PENDING_AUDIT)" v-hasPermi="['retail:purchase:approve']">
            <a-icon type="check" />审核
          </a>
          <a-divider type="vertical" v-if="hasItemStatus(record, ITEM_STATUS.APPROVED)" />
          <a @click="handleShip(record)" v-if="hasItemStatus(record, ITEM_STATUS.APPROVED)" v-hasPermi="['retail:purchase:ship']">
            <a-icon type="gift" />发货
          </a>
          <a-divider type="vertical" v-if="hasItemStatus(record, ITEM_STATUS.SHIPPED)" />
          <a @click="handleReceive(record)" v-if="hasItemStatus(record, ITEM_STATUS.SHIPPED)" v-hasPermi="['retail:purchase:receive']">
            <a-icon type="inbox" />收货
          </a>
          <a-divider type="vertical" v-if="hasItemStatus(record, ITEM_STATUS.PENDING_AUDIT)" />
          <a @click="handleCancel(record)" v-if="hasItemStatus(record, ITEM_STATUS.PENDING_AUDIT)" style="color: red" v-hasPermi="['retail:purchase:cancel']">
            <a-icon type="close" />取消
          </a>
        </span>
      </a-table>
    </a-card>

    <!-- 商品要货数量汇总（按当前筛选条件统计） -->
    <a-card :bordered="false" style="margin-top: 16px;" title="商品要货数量汇总">
      <a-radio-group slot="extra" v-model="summaryType" size="small">
        <a-radio-button value="goods">按商品</a-radio-button>
        <a-radio-button value="sku">按商品+SKU</a-radio-button>
      </a-radio-group>
      <a-table
        rowKey="rowKey"
        :columns="summaryColumns"
        :data-source="summaryRows"
        :loading="summaryLoading"
        :pagination="false"
        size="small"
        :scroll="{ x: 1200 }"
      />
      <div style="margin-top: 12px; text-align: right; color: #666;">
        要货数量总计：<span style="font-weight: 600; color: #1890ff;">{{ summaryTotalApplyCount }}</span>
        <template v-if="!isWarehouseManager">
          要货金额总计：<span style="font-weight: 600; color: #1890ff;">{{ formatAmount(summaryTotalApplyAmount) }}</span>
          已发货金额总计：<span style="font-weight: 600; color: #1890ff;">{{ formatAmount(summaryTotalShipAmount) }}</span>
          已收货金额总计：<span style="font-weight: 600; color: #1890ff;">{{ formatAmount(summaryTotalReceiveAmount) }}</span>
        </template>
      </div>
    </a-card>

    <!-- 要货单详情弹窗 -->
    <a-modal
      title="要货单详情"
      :visible="detailVisible"
      :footer="null"
      @cancel="detailVisible = false"
      width="1300px"
    >
      <a-descriptions bordered :column="2" v-if="currentDetail">
        <a-descriptions-item label="要货单号">{{ currentDetail.orderNo }}</a-descriptions-item>
        <a-descriptions-item label="门店名称">{{ currentDetail.storeName }}</a-descriptions-item>
        <a-descriptions-item label="商家名称">{{ currentDetail.merchantName }}</a-descriptions-item>
        <a-descriptions-item label="要货状态">
          <a-tag :color="getStatusColor(currentDetail.orderStatus)">{{ getStatusText(currentDetail.orderStatus) }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="期望到货日期">{{ parseDate(currentDetail.expectDate) }}</a-descriptions-item>
        <a-descriptions-item label="申请时间">{{ parseTime(currentDetail.createTime) }}</a-descriptions-item>
        <a-descriptions-item label="审核时间">{{ parseTime(currentDetail.approveTime) }}</a-descriptions-item>
        <a-descriptions-item label="发货时间">{{ parseTime(currentDetail.shipTime) }}</a-descriptions-item>
        <a-descriptions-item label="收货时间">{{ parseTime(currentDetail.receiveTime) }}</a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">{{ currentDetail.remark || '-' }}</a-descriptions-item>
      </a-descriptions>
      <a-divider>明细</a-divider>
      <a-table
        rowKey="id"
        :columns="itemColumns"
        :data-source="currentDetail?.items || []"
        :pagination="false"
        size="small"
      >
        <span slot="itemStatus" slot-scope="text">
          <a-tag :color="getItemStatusColor(text)">{{ getItemStatusText(text) }}</a-tag>
        </span>
      </a-table>
      <!-- 汇总统计（仓库管理角色不展示金额） -->
      <div v-if="!isWarehouseManager" style="margin-top: 16px; text-align: right; background: #f5f5f5; padding: 16px; border-radius: 4px;">
        <a-statistic
          title="申请总金额"
          :value="totalAmount"
          :precision="2"
          prefix="¥"
        />
      </div>
    </a-modal>

    <!-- 审核弹窗（按商品行级审核） -->
    <approve-modal ref="approveModal" @ok="getList" />

    <!-- 取消弹窗（按商品行级取消） -->
    <cancel-modal ref="cancelModal" @ok="getList" />

    <!-- 发货弹窗 -->
    <ship-modal ref="shipModal" @submit="handleShipSubmit" />

    <!-- 收货弹窗 -->
    <a-modal
      title="收货入库"
      :visible="receiveVisible"
      @ok="handleReceiveSubmit"
      @cancel="handleReceiveCancel"
      width="900px"
      :ok-button-props="{ loading: receiveLoading }"
    >
      <a-table
        rowKey="id"
        :columns="receiveColumns"
        :data-source="receiveItems"
        :pagination="false"
        size="small"
      >
        <span slot="itemStatus" slot-scope="text">
          <a-tag :color="getItemStatusColor(text)">{{ getItemStatusText(text) }}</a-tag>
        </span>
        <span slot="receivedCount" slot-scope="text, record">
          <a-input-number
            v-model="record.receivedCount"
            :min="0"
            :max="record.maxReceiveCount"
            :precision="0"
            style="width: 100px"
          />
        </span>
      </a-table>
    </a-modal>

    <!-- 报损类型选择弹窗 -->
    <a-modal
      title="选择报损类型"
      :visible="lossTypeVisible"
      @ok="handleLossTypeSubmit"
      @cancel="lossTypeVisible = false"
      width="500px"
    >
      <a-alert
        message="检测到有商品收货数量小于要货数量"
        description="请选择报损类型"
        type="info"
        show-icon
        style="margin-bottom: 16px;"
      />
      <a-radio-group v-model="lossType" style="width: 100%; display: block;">
        <a-radio :value="1" style="display: block; margin-bottom: 16px;">
          <span style="font-weight: 500;">门店承担</span>
<!--          <span style="color: #999; margin-left: 8px;">（无需审核）</span>-->
        </a-radio>
        <a-radio :value="2" style="display: block;">
          <span style="font-weight: 500;">平台承担</span>
<!--          <span style="color: #999; margin-left: 8px;">（需要审核）</span>-->
        </a-radio>
      </a-radio-group>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { getPurchaseOrderList, getPurchaseOrderDetail, shipPurchaseOrder, receivePurchaseOrder, getPurchaseGoodsSummary } from '@/api/retail/purchase'
import CreateForm from './modules/CreateForm'
import ShipModal from './modules/ShipModal'
import ApproveModal from './modules/ApproveModal'
import CancelModal from './modules/CancelModal'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

// 仓库管理角色标识：该角色仅可查看商品名称与数量，不可查看任何金额
const WAREHOUSE_ROLE_KEYS = ['仓库管理']

// 要货明细行状态：0待审核 1已审核 2已发货 3已取消 4已收货 5审核驳回
const ITEM_STATUS = {
  PENDING_AUDIT: 0,
  APPROVED: 1,
  SHIPPED: 2,
  CANCELLED: 3,
  RECEIVED: 4,
  REJECTED: 5
}

export default {
  name: 'Purchase',
  components: {
    CreateForm,
    ShipModal,
    ApproveModal,
    CancelModal
  },
  mixins: [tableMixin],
  data() {
    return {
      // 明细行状态常量：模板表达式会被编译成 _vm.xxx，必须挂到 data 才能在模板中访问
      ITEM_STATUS,
      list: [],
      loading: false,
      detailVisible: false,
      receiveVisible: false,
      currentDetail: null,
      receiveItems: [],
      receiveOrderId: null,
      lossType: 1,
      lossTypeVisible: false,
      receiveLoading: false,
      dateRange: [],
      dateRanges: {
        '今天': [moment(), moment()],
        '近7天': [moment().subtract(6, 'days'), moment()],
        '近30天': [moment().subtract(29, 'days'), moment()]
      },
      summaryList: [],
      summaryLoading: false,
      summaryType: 'goods',
      queryParam: {
        orderNo: undefined,
        storeName: undefined,
        merchantName: undefined,
        goodsName: undefined,
        orderStatus: undefined,
        beginTime: undefined,
        endTime: undefined,
        pageNo: 1,
        pageSize: 10
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        {
          title: '要货单号',
          dataIndex: 'orderNo',
          width: 180,
          align: 'center'
        },
        {
          title: '门店名称',
          dataIndex: 'storeName',
          width: 150,
          align: 'center'
        },
        {
          title: '商家名称',
          dataIndex: 'merchantName',
          width: 150,
          align: 'center'
        },
        {
          title: '期望到货日期',
          dataIndex: 'expectDate',
          width: 120,
          align: 'center'
        },
        {
          title: '要货状态',
          dataIndex: 'orderStatus',
          width: 100,
          scopedSlots: { customRender: 'orderStatus' },
          align: 'center'
        },
        {
          title: '明细进度',
          dataIndex: 'finishedItemCount',
          width: 100,
          scopedSlots: { customRender: 'progress' },
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 250,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      receiveColumns: [
        { title: '商品名称', dataIndex: 'goodsName', width: 150, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 120, align: 'center' },
        { title: '状态', dataIndex: 'itemStatus', scopedSlots: { customRender: 'itemStatus' }, width: 90, align: 'center' },
        { title: '要货数量', dataIndex: 'applyCount', width: 100, align: 'center' },
        { title: '发货数量', dataIndex: 'shipCount', width: 100, align: 'center' },
        { title: '已收数量', dataIndex: 'receiveCount', width: 100, align: 'center' },
        { title: '本次收货数量', dataIndex: 'receivedCount', scopedSlots: { customRender: 'receivedCount' }, width: 130, align: 'center' }
      ]
    }
  },
  computed: {
    // 当前登录用户是否为仓库管理角色
    isWarehouseManager() {
      const roles = this.$store.getters.roles || []
      const roleList = Array.isArray(roles) ? roles : Array.from(roles)
      return WAREHOUSE_ROLE_KEYS.some(key => roleList.includes(key))
    },
    // 明细列：仓库管理角色只展示商品名称与数量，隐藏所有金额列
    itemColumns() {
      const goodsColumns = [
        { title: '商品名称', dataIndex: 'goodsName', width: 200, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 150, align: 'center' }
      ]
      const statusColumn = { title: '状态', dataIndex: 'itemStatus', width: 90, align: 'center', scopedSlots: { customRender: 'itemStatus' } }
      const applyCountColumn = { title: '要货数量', dataIndex: 'applyCount', width: 100, align: 'center' }
      const shipCountColumn = { title: '发货数量', dataIndex: 'shipCount', width: 100, align: 'center' }
      const receiveCountColumn = { title: '收货数量', dataIndex: 'receiveCount', width: 100, align: 'center' }
      if (this.isWarehouseManager) {
        return [...goodsColumns, statusColumn, applyCountColumn, shipCountColumn, receiveCountColumn]
      }
      return [
        ...goodsColumns,
        statusColumn,
        { title: '门店拿货价(元)', dataIndex: 'unitPrice', width: 110, align: 'center', customRender: (text) => `¥${text ? parseFloat(text).toFixed(2) : '0.00'}` },
        { title: '门店销售价(元)', dataIndex: 'salePrice', width: 110, align: 'center', customRender: (text) => `¥${text ? parseFloat(text).toFixed(2) : '0.00'}` },
        applyCountColumn,
        shipCountColumn,
        { title: '小计金额(元)', dataIndex: 'amount', width: 120, align: 'center', customRender: (text, record) => `¥${((record.unitPrice || 0) * (record.applyCount || 0)).toFixed(2)}` },
        receiveCountColumn
      ]
    },
    // 汇总列：按商品或按商品+SKU
    summaryColumns() {
      const columns = [
        { title: '商品名称', dataIndex: 'goodsName', width: 200, align: 'center' }
      ]
      if (this.summaryType === 'sku') {
        columns.push({ title: 'SKU名称', dataIndex: 'skuName', width: 160, align: 'center' })
      }
      columns.push(
        { title: '要货数量合计', dataIndex: 'totalApplyCount', width: 140, align: 'center' },
        { title: '已发货数量合计', dataIndex: 'totalShipCount', width: 140, align: 'center' },
        { title: '已收货数量合计', dataIndex: 'totalReceiveCount', width: 140, align: 'center' }
      )
      // 仓库管理角色不可查看任何金额
      if (!this.isWarehouseManager) {
        columns.push(
          { title: '要货金额合计(元)', dataIndex: 'totalApplyAmount', width: 140, align: 'center', customRender: text => this.formatAmount(text) },
          { title: '已发货金额合计(元)', dataIndex: 'totalShipAmount', width: 140, align: 'center', customRender: text => this.formatAmount(text) },
          { title: '已收货金额合计(元)', dataIndex: 'totalReceiveAmount', width: 140, align: 'center', customRender: text => this.formatAmount(text) }
        )
      }
      return columns
    },
    // 汇总数据：按商品粒度合并同一商品（如玉米）的各SKU数量
    summaryRows() {
      const list = this.summaryList || []
      if (this.summaryType === 'sku') {
        return list.map((item, index) => ({
          ...item,
          rowKey: `${item.goodsId}_${item.skuId}_${index}`
        }))
      }
      const goodsMap = new Map()
      list.forEach(item => {
        const goodsName = item.goodsName || '未知商品'
        const row = goodsMap.get(goodsName) || {
          rowKey: goodsName,
          goodsName: goodsName,
          totalApplyCount: 0,
          totalShipCount: 0,
          totalReceiveCount: 0,
          totalApplyAmount: 0,
          totalShipAmount: 0,
          totalReceiveAmount: 0
        }
        row.totalApplyCount += item.totalApplyCount || 0
        row.totalShipCount += item.totalShipCount || 0
        row.totalReceiveCount += item.totalReceiveCount || 0
        row.totalApplyAmount += Number(item.totalApplyAmount) || 0
        row.totalShipAmount += Number(item.totalShipAmount) || 0
        row.totalReceiveAmount += Number(item.totalReceiveAmount) || 0
        goodsMap.set(goodsName, row)
      })
      return Array.from(goodsMap.values()).sort((a, b) => b.totalApplyCount - a.totalApplyCount)
    },
    summaryTotalApplyCount() {
      return this.summaryRows.reduce((total, row) => total + (row.totalApplyCount || 0), 0)
    },
    summaryTotalApplyAmount() {
      return this.summaryRows.reduce((total, row) => total + (Number(row.totalApplyAmount) || 0), 0)
    },
    summaryTotalShipAmount() {
      return this.summaryRows.reduce((total, row) => total + (Number(row.totalShipAmount) || 0), 0)
    },
    summaryTotalReceiveAmount() {
      return this.summaryRows.reduce((total, row) => total + (Number(row.totalReceiveAmount) || 0), 0)
    },
    totalAmount() {
      if (!this.currentDetail?.items) {
        return 0
      }
      return this.currentDetail.items.reduce((total, item) => {
        return total + ((item.unitPrice || 0) * (item.applyCount || 0))
      }, 0)
    }
  },
  created() {
    this.getList()
  },
  methods: {
    moment,
    parseTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    parseDate(time) {
      return time ? moment(time).format('YYYY-MM-DD') : '-'
    },
    // 金额格式化：¥0.00
    formatAmount(amount) {
      return `¥${(Number(amount) || 0).toFixed(2)}`
    },
    getStatusText(status) {
      const map = { 0: '待审核', 1: '已审核', 2: '已发货', 3: '已取消', 4: '已入库', 5: '审核拒绝' }
      return map[status] || '-'
    },
    getStatusColor(status) {
      const map = { 0: 'orange', 1: 'blue', 2: 'cyan', 3: 'red', 4: 'green', 5: 'purple' }
      return map[status] || 'default'
    },
    getItemStatusText(status) {
      const map = { 0: '待审核', 1: '已审核', 2: '已发货', 3: '已取消', 4: '已收货', 5: '审核驳回' }
      return map[status] || '-'
    },
    getItemStatusColor(status) {
      const map = { 0: 'orange', 1: 'blue', 2: 'cyan', 3: 'red', 4: 'green', 5: 'purple' }
      return map[status] || 'default'
    },
    // 判断要货单下是否存在指定状态的明细行
    hasItemStatus(record, status) {
      if (!record) {
        return false
      }
      const items = record.items || []
      if (items.length === 0) {
        // 明细未返回时退化为按主单状态判断（主单与行状态码一致）
        return record.orderStatus === status
      }
      return items.some(item => item.itemStatus === status)
    },
    // reloadSummary：仅筛选条件变化时才重新统计汇总，翻页不必重复统计
    getList(reloadSummary = true) {
      this.buildTimeParam()
      this.loading = true
      getPurchaseOrderList(this.queryParam).then(response => {
        this.list = response.data?.records || []
        this.pagination.total = response.data?.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
      if (reloadSummary) {
        this.loadSummary()
      }
    },
    // 将日期区间转换为起止时间(含当天23:59:59)
    buildTimeParam() {
      const range = this.dateRange || []
      this.queryParam.beginTime = range[0] ? `${range[0]} 00:00:00` : undefined
      this.queryParam.endTime = range[1] ? `${range[1]} 23:59:59` : undefined
    },
    // 按当前筛选条件加载商品要货数量汇总
    loadSummary() {
      this.summaryLoading = true
      const { orderNo, storeName, merchantName, goodsName, orderStatus, beginTime, endTime } = this.queryParam
      getPurchaseGoodsSummary({ orderNo, storeName, merchantName, goodsName, orderStatus, beginTime, endTime }).then(response => {
        this.summaryList = response.data || []
        this.summaryLoading = false
      }).catch(() => {
        this.summaryLoading = false
      })
    },
    handleTableChange(pagination) {
      this.queryParam.pageNo = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList(false)
    },
    handleQuery() {
      this.queryParam.pageNo = 1
      this.getList()
    },
    resetQuery() {
      this.dateRange = []
      this.queryParam = {
        orderNo: undefined,
        storeName: undefined,
        merchantName: undefined,
        goodsName: undefined,
        orderStatus: undefined,
        beginTime: undefined,
        endTime: undefined,
        pageNo: 1,
        pageSize: 10
      }
      this.getList()
    },
    handleDetail(record) {
      getPurchaseOrderDetail({ orderId: record.id }).then(response => {
        this.currentDetail = response.data
        this.detailVisible = true
      })
    },
    handleApprove(record) {
      // 加载要货单明细,按商品行级审核
      getPurchaseOrderDetail({ orderId: record.id }).then(response => {
        this.$refs.approveModal.open(response.data)
      })
    },
    handleShip(record) {
      // 先获取要货单详情,检查库存情况
      getPurchaseOrderDetail({ orderId: record.id }).then(response => {
        const orderData = response.data

        // 为每个商品计算平台库存是否充足(决定默认发货方式)
        if (orderData.items && orderData.items.length > 0) {
          orderData.items.forEach(item => {
            const stock = item.stockCount || 0
            item.inStock = stock >= (item.applyCount || 0)
            item.availableStock = Math.min(stock, item.applyCount || 0)
          })
        }

        // 打开发货弹窗
        this.$refs.shipModal.open(orderData)
      })
    },
    handleShipSubmit(data) {
      // 直接执行发货，不再处理直发采购入库
      // 直发采购的商品会由供应商直接发货给门店，在收货时才会入库
      shipPurchaseOrder(data).then(() => {
        this.$message.success('发货成功')
        this.$refs.shipModal.visible = false
        this.getList()
      }).catch(() => {
        this.$refs.shipModal.loading = false
      })
    },
    handleReceive(record) {
      getPurchaseOrderDetail({ orderId: record.id }).then(response => {
        // 只有已发货的商品才能收货
        this.receiveItems = (response.data.items || [])
          .filter(item => item.itemStatus === ITEM_STATUS.SHIPPED)
          .map(item => {
            // 本次可收数量 = 发货数量 - 已收数量
            const maxReceiveCount = Math.max((item.shipCount || 0) - (item.receiveCount || 0), 0)
            return {
              ...item,
              maxReceiveCount,
              receivedCount: maxReceiveCount
            }
          })
        this.receiveOrderId = record.id
        this.lossType = 1
        this.receiveVisible = true
      })
    },
    handleReceiveCancel() {
      this.receiveVisible = false
    },
    handleReceiveSubmit() {
      const items = this.receiveItems.map(item => ({
        itemId: item.id,
        receiveCount: item.receivedCount
      }))

      // 检查是否有需要报损的商品(收货数量小于实际发货数量)
      const hasLossItems = this.receiveItems.some(item => item.receivedCount < item.shipCount)

      // 如果有报损商品，弹出报损类型选择弹窗
      if (hasLossItems) {
        this.receiveVisible = false
        this.lossTypeVisible = true
      } else {
        // 没有报损，直接收货
        this.executeReceive(items)
      }
    },
    // 执行收货操作
    executeReceive(items, lossType = null) {
      this.receiveLoading = true
      const requestData = {
        orderId: this.receiveOrderId,
        items: items
      }

      // 如果有报损类型，传入收货接口
      if (lossType) {
        requestData.lossType = lossType
      }

      receivePurchaseOrder(requestData).then(() => {
        this.receiveLoading = false
        this.receiveVisible = false
        this.lossTypeVisible = false
        this.$message.success('收货成功')
        this.getList()
      }).catch(() => {
        this.receiveLoading = false
      })
    },
    // 提交报损类型
    handleLossTypeSubmit() {
      const items = this.receiveItems.map(item => ({
        itemId: item.id,
        receiveCount: item.receivedCount
      }))

      // 执行收货，传入报损类型
      this.executeReceive(items, this.lossType)
    },
    handleCancel(record) {
      // 加载要货单明细,按商品行级取消,其余商品可继续走流程
      getPurchaseOrderDetail({ orderId: record.id }).then(response => {
        this.$refs.cancelModal.open(response.data)
      })
    }
  }
}
</script>
